import FaqItem from "./FaqItem";

function FaqSection() {
  const switchTab1 = (e) => {
    e.preventDefault();
    const nav = document.querySelector("nav");
    const rect = nav.getBoundingClientRect();
    window.scrollBy({
      left: 0,
      top: rect.top,
      behavior: "smooth",
    });
    setTimeout(function () {
      const button = document.querySelector(
        `button[data-hs-tab="#tabs-with-card-1"]`
      );
      button.click();
    }, 100);
  };

  return (
    <div className="bg-slate-100 px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
      <div className="max-w-2xl mx-auto mb-10 lg:mb-14">
        <h2 className="text-2xl font-bold md:text-4xl md:leading-tight">
          よくあるご質問
        </h2>
      </div>

      <div className="max-w-2xl mx-auto divide-y divide-gray-200">
        <FaqItem question="保険証利用登録したか忘れてしまいました。">
          マイナポータルで確認できます。
          <a href="#tabs-with-card-1" onClick={switchTab1}>
            こちら
          </a>
          をご参照ください。
        </FaqItem>
        <FaqItem question="資格情報のお知らせが送られてきません。">
          ご加入の健康保険組合ごとに交付スケジュールは異なります。ご加入の健康保険組合のホームページ等でご確認ください。
        </FaqItem>
        <FaqItem question="保険証を紛失しました。">
          有効期限内（2025年5月31日まで）の保険証を紛失した場合は、警察に届け出るとともに健康保険組合にご連絡ください。くわしくはご加入の健康保険組合のホームページをご確認ください。
          <br />
          なお、現行の保険証の廃止後（2024年12月2日以降）は、保険証の再発行はできません。マイナ保険証をご利用いただくか、マイナ保険証が利用できな場合は健康保険組合に資格確認書を申請をご利用ください。
        </FaqItem>
        <FaqItem question="資格確認書を発行してほしい。">
          資格確認書は、令和6年12月2日以降、資格取得届などによる本人からの申し出によりマイナ保険証をお持ちでない加入者に交付されます。このため現時点で交付することはできません。
          <br />
          また、有効な保険証を持っている方には資格確認書を交付しなくてもよいとされているため、希望しても交付されない場合がありますのであらかじめご承知おきください。
        </FaqItem>
      </div>
    </div>
  );
}

export default FaqSection;
